import React from 'react';
import { Card, Col, Row, Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import MainLayout from '../../../../components/MainLayout/MainLayout';
import PageHeader from '../../../../components/PageHeader/PageHeader';
import GatewaysTable from '../GatewaysTable/GatewaysTable';
import SensorsTable from '../SensorsTable/SensorsTable';

const DataWarehouse = () => {
    const { t } = useTranslation(['clients', 'common']);
    const { clientId } = useParams<{ clientId: string }>();

    const breadcrumbCrumbs = [
        { title: t('common:dashboard'), path: '/dashboard' },
        { title: t('clients:clients'), path: '/clients' },
        { title: t('clients:data_warehouse') }
    ];

    if (!clientId) {
        return <div>{t('common:client_id_not_found')}</div>;
    }

    return (
        <MainLayout>
            <PageHeader crumbs={breadcrumbCrumbs} />
            <Row style={{ paddingBottom: 24 }}>
                <Col xs={24}>
                    <Card style={{ marginBottom: 24 }}>
                        <GatewaysTable clientId={clientId} />
                    </Card>
                    <Card>
                        <SensorsTable clientId={clientId} />
                    </Card>
                </Col>
            </Row>
        </MainLayout>
    );
};

export default DataWarehouse;